import { type IntlShape } from '@formatjs/intl'
import { type IntlShape as ReactIntlShape } from 'react-intl'

import { priceGetFormattedPrice } from '../price'

/**
 * The function reformats price coming from Gk-Air
 *
 * Gk-Air price format:
 * ```
 * ┌─ currency sign (€) or code (CHF)
 * │ ┌─ integer
 * │ │ ┌─ decimal (dot)
 * │ │ │     ┌─ optional unit
 * € 10,36 / st
 * ```
 */
export const gkAirGetFormattedPrice = ({
  intl,
  price,
  unit,
}: {
  intl: IntlShape | ReactIntlShape
  price: string
  unit?: string | null
}): string | undefined => {
  const amount = Number.parseFloat(price)

  let formattedPrice = priceGetFormattedPrice(amount, intl)

  if (unit?.length) {
    formattedPrice += ` / ${unit}`
  }

  return formattedPrice
}
